import { getConfigDeadlineUrl } from "../config/Config";
import { getRequest, postRequest } from "./ServiceHelper";

export class ConfigService {
  static getGlobalDaysAfterTermDeadline() {
    return getRequest(getConfigDeadlineUrl());
  }

  static setGlobalDaysAfterTermDeadline(days) {
    const body = { days };
    return postRequest(getConfigDeadlineUrl(), body);
  }
}
